import { render } from "./CaracProduto.vue?vue&type=template&id=8ce170fa&scoped=true"
import script from "./CaracProduto.vue?vue&type=script&lang=js"
export * from "./CaracProduto.vue?vue&type=script&lang=js"

import "./CaracProduto.vue?vue&type=style&index=0&id=8ce170fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce170fa"]])

export default __exports__